import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c1ef9b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "partner-requests page-header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Contact Form Submissions")
], -1))
const _hoisted_2 = { class: "partner-requests page" }
const _hoisted_3 = {
  key: 0,
  class: "noResults"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "No Recent Contact Form Submissions", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "row"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 3,
  class: "btn-row"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-fill" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Page")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-fill" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Page ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.all_emails == '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.all_emails != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData, (contact, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-20 card",
                key: index
              }, [
                (contact.name != null)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString(contact.name), 1))
                  : _createCommentVNode("", true),
                (contact.email != null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(contact.email), 1))
                  : _createCommentVNode("", true),
                (contact.message != null)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_9, "Message"))
                  : _createCommentVNode("", true),
                (contact.message != null)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 3,
                      innerHTML: contact.message
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: ($event: any) => (_ctx.contactPotentialClient(contact))
                }, "Contact", 8, _hoisted_11)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.totalPages !== null || _ctx.totalPages !== undefined || _ctx.totalPages >>> 1)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Page " + _toDisplayString(_ctx.page) + " of " + _toDisplayString(_ctx.totalPages), 1))
        : _createCommentVNode("", true),
      (_ctx.totalPages >>> 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevPage()))
            }, _hoisted_16),
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextPage()))
            }, _hoisted_19)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}